//@ts-check
import React from 'react';
import { Communication } from 'ecrion-components';

/**
 * @param {import('../../utils/types').FileInfo} file
 * @param {string} name
 * @returns {string}
 */
const getTagValue = (file, name) => {
  const { Tags: tags } = file;
  if (!tags || !tags.length) return;

  const tag = tags.find((t) => t.Name === name);
  return tag && tag.Value;
};

/**
 * @param {Array<import('./types').Parameter>} parameters
 */
const getContactId = (parameters) => {
  if (!parameters) return '';

  const contactIdParam = parameters.find(
    (p) => p.name.toLowerCase() === 'contactid'
  );

  return contactIdParam && contactIdParam.value;
};

const notifyOnSubmit = () => {
  try {
    window.parent && window.parent.postMessage(['formSubmitted'], '*');
  } catch { }
};

/**
 * @param {import('./types').CommunicationProps} param
 */
const Public = ({ data, parameters, showToolbar }) => {
  const [job, setJob] = React.useState(null);

  const { AccessToken: token } = data;

  const communicationId = getTagValue(data.File, 'CommunicationId');
  const jobId = getTagValue(data.File, 'JobId');

  const contactId = getContactId(parameters);
  const isInIFrame = window.self !== window.top;

  const runProps = {
    projectId: communicationId,
    contactId,
    token,
    parameters,
    showToolbar: showToolbar && !isInIFrame,
  };
  const onJobStarted = (jobSummary) => {
    isInIFrame && notifyOnSubmit();

    setJob(
      jobSummary && { jobId: jobSummary.Id, workspace: jobSummary.Workspace }
    );
  };

  if (job)
    return (
      <Communication.Run.JobDetails
        jobId={job.jobId}
        workspace={job.workspace}
        variant="portal"
        {...runProps}
      />
    );

  return (
    <Communication.Run.Frame
      {...runProps}
      jobId={jobId}
      onJobStarted={onJobStarted}
      disableJobSaving // disable job save for public link
      disableRepositoryAccess // repository access not available for running in portal
      variant="portal"
    />
  );
};

export default Public;
